import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { studentAPI } from '../services/api';

function StudentAccess() {
    const [testPassword, setTestPassword] = useState('');
    const [studentName, setStudentName] = useState('');
    const [test, setTest] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(1); // 1: Passwort, 2: Name, 3: Test
    
    const navigate = useNavigate();

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await studentAPI.accessTest(testPassword);
            setTest(response.data.test);
            setQuestions(response.data.questions);
            setStep(2);
        } catch (err) {
            setError(err.response?.data?.error || 'Test nicht gefunden');
        } finally {
            setLoading(false);
        }
    };

    const handleNameSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await studentAPI.validateStudent(test.id, studentName);
            setStep(3);
        } catch (err) {
            const errorMsg = err.response?.data?.error || 'Name nicht in der Liste';
            setError(errorMsg);
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h1 style={styles.title}>Schüler-Bereich</h1>

                {error && <div style={styles.error}>{error}</div>}

                {step === 1 && (
                    <form onSubmit={handlePasswordSubmit}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Test-Passwort</label>
                            <input
                                type="text"
                                value={testPassword}
                                onChange={(e) => setTestPassword(e.target.value)}
                                required
                                style={styles.input}
                                placeholder="Passwort eingeben"
                                autoFocus
                            />
                        </div>

                        <button type="submit" disabled={loading} style={styles.button}>
                            {loading ? 'Lädt...' : 'Test öffnen'}
                        </button>

                        <p style={styles.footer}>
                            <button 
                                type="button"
                                onClick={() => navigate('/login')}
                                style={styles.linkButton}
                            >
                                Zur Lehrkraft-Anmeldung
                            </button>
                        </p>
                    </form>
                )}

                {step === 2 && (
                    <div>
                        <div style={styles.testInfo}>
                            <h2>{test.title}</h2>
                            {test.description && <p>{test.description}</p>}
                            {test.time_limit && (
                                <p style={styles.timeLimit}>⏱️ Zeitlimit: {test.time_limit} Minuten</p>
                            )}
                        </div>

                        <form onSubmit={handleNameSubmit}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Dein Name</label>
                                <input
                                    type="text"
                                    value={studentName}
                                    onChange={(e) => setStudentName(e.target.value)}
                                    required
                                    style={styles.input}
                                    placeholder="Vor- und Nachname"
                                    autoFocus
                                />
                                <small style={styles.hint}>
                                    Gib deinen Namen genau so ein, wie von der Lehrkraft angegeben.
                                </small>
                            </div>

                            <button type="submit" disabled={loading} style={styles.button}>
                                {loading ? 'Prüfe...' : 'Test starten'}
                            </button>

                            <button 
                                type="button"
                                onClick={() => {
                                    setStep(1);
                                    setTest(null);
                                    setQuestions([]);
                                    setError('');
                                }}
                                style={styles.backButton}
                            >
                                ← Zurück
                            </button>
                        </form>
                    </div>
                )}

                {step === 3 && (
                    <div>
                        <div style={styles.success}>
                            ✓ Erfolgreich angemeldet!
                        </div>
                        <p>Leite weiter zum Test...</p>
                        {setTimeout(() => {
                            navigate('/take-test', { 
                                state: { test, questions, studentName } 
                            });
                        }, 1500)}
                    </div>
                )}
            </div>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
    },
    card: {
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '500px',
    },
    title: {
        textAlign: 'center',
        marginBottom: '1.5rem',
        color: '#333',
    },
    formGroup: {
        marginBottom: '1rem',
    },
    label: {
        display: 'block',
        marginBottom: '0.5rem',
        fontWeight: 'bold',
        color: '#555',
    },
    input: {
        width: '100%',
        padding: '0.75rem',
        border: '1px solid #ddd',
        borderRadius: '4px',
        fontSize: '1rem',
        boxSizing: 'border-box',
    },
    hint: {
        display: 'block',
        marginTop: '0.25rem',
        color: '#666',
        fontSize: '0.85rem',
    },
    button: {
        width: '100%',
        padding: '0.75rem',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        marginTop: '1rem',
    },
    backButton: {
        width: '100%',
        padding: '0.75rem',
        backgroundColor: '#6c757d',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        fontSize: '1rem',
        cursor: 'pointer',
        marginTop: '0.5rem',
    },
    linkButton: {
        background: 'none',
        border: 'none',
        color: '#007bff',
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: 0,
    },
    error: {
        backgroundColor: '#fee',
        color: '#c33',
        padding: '0.75rem',
        borderRadius: '4px',
        marginBottom: '1rem',
    },
    success: {
        backgroundColor: '#d4edda',
        color: '#155724',
        padding: '1rem',
        borderRadius: '4px',
        marginBottom: '1rem',
        textAlign: 'center',
        fontSize: '1.2rem',
        fontWeight: 'bold',
    },
    testInfo: {
        padding: '1rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        marginBottom: '1.5rem',
    },
    timeLimit: {
        color: '#856404',
        fontWeight: 'bold',
        marginTop: '0.5rem',
    },
    footer: {
        textAlign: 'center',
        marginTop: '1rem',
        color: '#666',
    },
};

export default StudentAccess;
